/* tslint:disable */
/* eslint-disable */
/**
 * Shifts API
 * API to get shifts
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShiftRequestResponse
 */
export interface ShiftRequestResponse {
    /**
     * Shift request ID
     * @type {number}
     * @memberof ShiftRequestResponse
     */
    id: number;
    /**
     * Shift request title
     * @type {string}
     * @memberof ShiftRequestResponse
     */
    title: string;
}

export function ShiftRequestResponseFromJSON(json: any): ShiftRequestResponse {
    return ShiftRequestResponseFromJSONTyped(json, false);
}

export function ShiftRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftRequestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
    };
}

export function ShiftRequestResponseToJSON(value?: ShiftRequestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
    };
}

